<template>

  <b-modal
    id="add-simulation-honoraire-modal"
    :ok-title="$t('Add')"
    :title="$t('Add') + ' ' + $t('SimulationHonoraire')"
    ok-only
    centered
    ok-variant="primary"
    @ok="handleOk">

    <AutocompleteField
      v-model="type"
      :input-class="'medium-label mb-4'"
      :input-id="'type-input'"
      :input-label="$t('simulationHonoraire.Type')"
      :items="types"
      :required=true
      @elementValueChanged="getSelectedValue">
    </AutocompleteField>

  </b-modal>

</template>

<script>

import AutocompleteField from "../../../components/b122/editFields/AutocompleteField";

export default {

  name: "AddSimulationHonoraireModal",

  components: {
    AutocompleteField
  },

  props: {
    simulation: {
      type: Object,
      default: null
    },
    simulationLot: {
      type: Object,
      default: null
    },
    types: {
      type: Array,
      default() {
        return []
      }
    }
  },

  data() {
    return {
      type: null,
    }
  },

  emits: ['didAddSimulationHonoraire'],

  methods: {

    getSelectedValue(data) {
      this.type = data
    },

    handleOk() {
      this.handleSubmit()
    },

    handleSubmit() {
      if (this.type != null && this.type.trim() !== '') {
        let simulationHonoraire = {
          simulation: this.simulation,
          simulationLot: this.simulationLot,
          type: this.type,
          prixTTC: null
        }
        this.$emit('didAddSimulationHonoraire', simulationHonoraire)
      }
      this.resetModal()
      this.hideModal()
    },

    resetModal() {
      this.type = null
    },

    hideModal() {
      this.$bvModal.hide('add-simulation-honoraire-modal')
    }

  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/simulation/components/AddSimulationHonoraireModal.vue